import { message } from 'antd';
import { Dispatch } from 'react';
import { IStateWebSocket } from 'src/entity/StateEntity';
import I18N from 'src/services/I18NService';
import NotifyService from 'src/services/NotifyService';
import { WSMessageType } from 'src/services/WebSocketService';

export function initWebSocketState(): IStateWebSocket {
  return {
    type: WSMessageType.初始状态,
    accountApprove: 0,
    accountConfigure: 0,
    order: 0,
    hasNewOrder: false,
  };
}

export function setAccountApprove(accountApprove: number): IStateWebSocket {
  return {
    type: WSMessageType.获取待审核医生,
    accountApprove,
    order: 0,
    hasNewOrder: false,
  };
}

export function setAccountConfigure(accountConfigure: number): IStateWebSocket {
  return {
    type: WSMessageType.获取待配置医生,
    accountConfigure,
    order: 0,
    hasNewOrder: false,
  };
}

export function setPendingOrder(order: number, hasNewOrder: boolean): IStateWebSocket {
  return {
    type: WSMessageType.获取待处理订单,
    accountApprove: 0,
    accountConfigure: 0,
    order,
    hasNewOrder: hasNewOrder && order > 0,
  };
}

export function setPreOrderSendStatus(orderUUID: string): IStateWebSocket {
  return {
    type: WSMessageType.发送药品清单结果,
    order_id: orderUUID,
  }
}

export function getDoctorToApprove(): any {
  return async (dispatch: Dispatch<IStateWebSocket>) => {
    try {
      const res = await NotifyService.getDoctorToApprove();
      const count = !!res ? res.count : 0;
      dispatch(setAccountApprove(count));
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_login_failure'));
      }
    }
  };
}

export function getDoctorNeedConfigure(): any {
  return async (dispatch: Dispatch<IStateWebSocket>) => {
    try {
      const res = await NotifyService.getDoctorNeedConfigure();
      const count = !!res ? res.count : 0;
      dispatch(setAccountConfigure(count));
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_login_failure'));
      }
    }
  };
}

export function getOrderPending(hasNewOrder: boolean): any {
  return async (dispatch: Dispatch<IStateWebSocket>) => {
    try {
      const res = await NotifyService.getOrderPending();
      const count = !!res ? res.count : 0;
      dispatch(setPendingOrder(count, hasNewOrder));
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_login_failure'));
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/webSocketCreator.ts